<template>
    <div class="dropdown-container" v-on-clickaway="closeDropdown" @click="$event.stopPropagation()">
        <div class="dropdown-button">
            <div style="display: inline">
                <template v-if="label !== null">
                    <div class="dropdown-label">
                        <div @click="selectDropdown" class="dropdown-label-text">{{ label }}</div>
                        <fa v-if="labelLoading === true" class="chevron" icon="spinner" spin></fa>
                        <fa v-else-if="disabled === false" class="chevron" icon="chevron-down" @click="selectDropdown"></fa>
                    </div>
                </template>
                <div v-else @click="selectDropdown">
                    <slot name="dropdownToggler"></slot>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <div v-if="show === true" class="dropdown-outside-toggle" :style="dropdownStyle">
                <div v-if="heading" @click="$event.stopPropagation()" class="dropdown-title"> {{heading}}</div>
                <slot name="dropdownContent"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
  import {mixin as clickaway} from 'vue-clickaway';
  import common from 'module/common';

  import scrollMixin from 'mixin/scroll';

  export default {
    mixins: [clickaway, scrollMixin],
    props: {
      menuWidth: {
        type: String,
        default: "240px"
      },
      heading: {
        type: String,
      },
      label: {
        type: String,
        default: null
      },
      labelLoading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        searchTerm: ''
      }
    },
    computed: {
      dropdownStyle() {
        return {
          width: this.menuWidth,
          transform: 'translateX(-50%)'
        }
      },

    },
    watch: {
      show: {
        immediate: true,
        handler() {
          this.$nextTick(() => {
            this.$emit('open');
          });
        }
      }
    },
    methods: {
      selectDropdown(event) {
        event.stopPropagation();

        if (this.disabled === true) {
          return;
        }

        this.showDropdown();

        this.$nextTick(() => {
          let menuElement = this.$el.querySelector(".dropdown-outside-toggle");

          if (this.show === true) {
            menuElement.style.top = event.clientY + 'px';
            menuElement.style.left = event.clientX + 'px';

            this.$nextTick(() => {
              common.keepElementInViewport(menuElement, event);
            });
          }
        });
      },
      showDropdown() {
        this.show = true;
      },
      closeDropdown() {
        this.show = false;
      },
    }
  }
</script>

<style lang="scss" scoped>
    .dropdown-container {
        position: relative;

        .dropdown-button {
            cursor: pointer;

            .dropdown-label {
                border-bottom: 1px solid transparent;
                display: flex;
                justify-content: center;
                align-items: center;

                .dropdown-label-text {
                    overflow: hidden;
                    text-overflow: ellipsis;

                    &:hover {
                        border-bottom: 1px solid white;
                    }
                }


                .chevron {
                    margin-left: 5px;
                    font-size: .8em;
                }
            }
        }

        .dropdown-outside-toggle {
            position: fixed;
            background-color: white;
            box-shadow: 0px 0px 27px 0px rgba(0, 0, 0, 0.35);
            color: $primary-font-color;
            display: flex;
            flex-direction: column;
            border: solid 5px $primary;
            z-index: 20;
            user-select: none;

            .dropdown-title {
                background-color: $primary;
                color: $primary-font-color;
                text-align: center;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                padding-bottom: 5px;
            }
        }
    }


    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: opacity .3s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
    }
</style>